import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { formatDate, notify, urlApiTMAN } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

const urlBaseUnit = process.env.REACT_APP_TMAN_API + '/Unit'
const urlBaseKilometraje = process.env.REACT_APP_TMAN_API + '/Unit/Mileage'

export const useKilometraje = () => {
    const { stateUser , signOut } = useContext(UserContext);
	const codEmpresa = stateUser.codEmpresa
    const COD_USUARIO = stateUser.codUsuario


    const [unidades,setUnidades] = useState([])
    const [kilometrajes,setKilometrajes] = useState([])
    const [ultimasLecturas,setUltimasLecturas] = useState(0)
    const [historialKilometraje,setHistorialKilometraje] = useState([])

    const listarUnidades = async () => {
        const response = await AuthFetch({
            url: urlBaseUnit + '?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setUnidades(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }
    
    const listarKilometrajes = async () => {
        const parametros = new URLSearchParams({
            codEmpresa: codEmpresa,
        })
        const response = await AuthFetch({
            url: urlBaseKilometraje + '/detail?' + parametros,
        })
        if(response.isValid){
            setKilometrajes(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarUltimasLecturas = async (codUnidad) => {
        const parametros = new URLSearchParams({
            codEmpresa: codEmpresa,
            codUnidad: codUnidad
        })
        const response = await AuthFetch({
            url: urlBaseKilometraje + '?' + parametros,
        })
        if(response.isValid){
            setUltimasLecturas(response.content?.ultimaLectura || 0)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const listarHistorialKilometraje = async (codUnidad) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Unit/Mileage/historical?' + new URLSearchParams({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad
            })
        })
        if(response.isValid){
            setHistorialKilometraje(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const registrarKilometraje = async ({
        codUnidad = 0,
        ultimaLectura = 0,
        observacion = ''
    }) => {
        const response = await AuthFetch({
            url: urlBaseKilometraje,
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUnidad: codUnidad,
                ultimaLectura: ultimaLectura,
                observacion: observacion,
                codUsuarioCreacion: COD_USUARIO
            })
        })

        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const editarKilometraje = async ({
        codUnidadKilometraje = 0,
        ultimaLectura = 0,
        observacion = ''
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Unit/Mileage',
            method: 'PUT',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUsuarioAccion: COD_USUARIO,
                codUnidadKilometraje: codUnidadKilometraje,
                ultimaLectura: ultimaLectura,
                observacion: observacion
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const eliminarKilometraje = async (codUnidadKilometraje,motivoAnulacion) => {
        const response = await AuthFetch({
            url: urlBaseKilometraje,
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: codEmpresa,
                codUnidadKilometraje: codUnidadKilometraje,
                motivoAnulacion: motivoAnulacion,
                codUsuarioAccion: stateUser.codUsuario
            })
        })
        
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    
    return {
        listarUnidades,
        unidades,
        listarKilometrajes,
        kilometrajes,
        listarUltimasLecturas,
        ultimasLecturas,
        registrarKilometraje,
        editarKilometraje,
        eliminarKilometraje,

        listarHistorialKilometraje,
        historialKilometraje
    };
};
